<template>
  <div class="users">
    <h1 class="users__title">
      Vos utilisateurs - Avocats
    </h1>

    <div class="users__table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Identifiant</th>
            <th>Prénom Nom</th>
            <th>Adresse de messagerie</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, index) in users" :key="index">
            <td>{{ user.id }}</td>
            <td>{{ user.firstname }} {{ user.lastname }}</td>
            <td>{{ user.email }}</td>
            <td>
              <button
                class="button button--x-small"
                @click="$router.push({ name: 'UserEdit', params: { id: user.id } })"
              >
                MODIFIER
              </button>
              <button
                class="button button--invalid button--x-small"
                @click="deleteUser(user)"
              >
                SUPPRIMER
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { api } from '@/lib/api';

export default {
  data() {
    return {
      users: [],
    };
  },
  async created() {
    this.refreshUsers();
  },
  methods: {
    async deleteUser(user) {
      if (confirm('Êtes vous sûr de vouloir de supprimer cet utilisateur ?')) {
        if (user.site) {
          await api.delete(user.site);
        }

        await api.delete(`/users/${user.id}`);

        this.refreshUsers();
      }
    },
    async refreshUsers() {
      const { data: users } = await api.get(`/users`);

      this.users = users['hydra:member'].filter(user => {
        return !user.roles.includes('ROLE_ADMIN');
      });
    },
  },
};
</script>
